export default __webpack_public_path__ + "static/media/delivery.933fefa5.webp";